import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const Webinar = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 24 24" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 5C9.51472 5 7.5 7.01472 7.5 9.5V16H5.25C3.45507 16 2 14.5449 2 12.75C2 10.9551 3.45507 9.5 5.25 9.5H5.5C5.5 5.91015 8.41015 3 12 3C15.5899 3 18.5 5.91015 18.5 9.5L18.75 9.5C20.5449 9.5 22 10.9551 22 12.75C22 14.5449 20.5449 16 18.75 16L18.5 16V16.5C18.5 18.433 16.933 20 15 20C15 21.1046 14.1046 22 13 22H11C9.89543 22 9 21.1046 9 20V18C9 16.8954 9.89543 16 11 16H13C14.1046 16 15 16.8954 15 18C15.8284 18 16.5 17.3284 16.5 16.5V9.5C16.5 7.01472 14.4853 5 12 5ZM4 12.75C4 12.0596 4.55964 11.5 5.25 11.5H5.5V14H5.25C4.55964 14 4 13.4404 4 12.75ZM18.75 14C19.4404 14 20 13.4404 20 12.75C20 12.0596 19.4404 11.5 18.75 11.5H18.5V14H18.75ZM11 20V18H13V20H11Z"
      fill="currentColor"
    />
  </Icon>
));

export default Webinar;
